import { render, staticRenderFns } from "./GenericChartComponent.vue?vue&type=template&id=338a852e"
import script from "./GenericChartComponent.vue?vue&type=script&lang=js"
export * from "./GenericChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports